import { Skeleton } from "@/components/ui/skeleton";

export default function ArchivedDealsSkeleton() {
  return (
    <div className="divide-y divide-dash-border overflow-hidden rounded-xl border border-dash-border bg-white" role="status" aria-label="Loading archived deals">
      {[0, 1, 2, 3].map((row) => (
        <div key={row} className="flex flex-wrap items-center gap-4 px-4 py-4 sm:gap-6 sm:px-6">
          <div className="min-w-0 flex-1">
            <Skeleton className="h-5 w-2/5" />
            <Skeleton className="mt-2 h-3 w-3/5" />
          </div>
          <Skeleton className="h-9 w-24 rounded-xl" />
          <Skeleton className="h-9 w-40 rounded-xl" />
        </div>
      ))}
      <span className="sr-only">Loading archived deals…</span>
    </div>
  );
}
